export default __webpack_public_path__ + "static/media/ams-aci-light.aaa1506d.svg";